// extracted by mini-css-extract-plugin
export default {"formHeading":"EnquiryForm_formHeading__qOX0E","enquiryForm":"EnquiryForm_enquiryForm__p1JH7","enquiryLabel":"EnquiryForm_enquiryLabel__pxOT2","formRow":"EnquiryForm_formRow__FbwlM"};